var render = function render(){var _vm=this,_c=_vm._self._c;return _c('summary-count',{attrs:{"title":_vm.title,"is-loading":_vm.isLoading,"count":_vm.count,"change-count":null,"tooltip":_vm.tooltipText},on:{"cardClicked":function($event){return _vm.gotoLink()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }